import { QRCodeCanvas } from "qrcode.react";
import { useRef } from "react";
import style from "../styles/modules/QRCode.module.css";

export const QRCode = ({ text }: { text: string }) => {
  const canvasRef = useRef<HTMLDivElement | null>(null);

  const handleDownload = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    const canvas = canvasRef.current?.querySelector(
      "canvas"
    ) as HTMLCanvasElement | null;
    if (!canvas) return;

    const url = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = url;
    link.download = `${text}.png`;
    link.click();
  };

  return (
    <div ref={canvasRef} className={style.qr}>
      <QRCodeCanvas value={text} />
      <button onClick={handleDownload}>QRコードをダウンロード</button>
    </div>
  );
};
